import React from "react";
import "./CustomDevelopmentOperationalFriction.css";

import customDevelopmentOperationalFrictionDarkBackground from "../../images/custom-development-operational-friction-dark-background.svg";
import customDevelopmentOperationalFrictionFragmentedWorkflowDesktop from "../../images/custom-development-operational-friction-fragmented-workflow-desktop.svg";
import customDevelopmentOperationalFrictionFragmentedWorkflowMobile from "../../images/custom-development-operational-friction-fragmented-workflow-mobile.svg";

const customDevelopmentOperationalFrictionSignals = [
  {
    number: "01",
    title: "Duplicate capture",
    body: "The same information is entered again across disconnected tools.",
    tone: "blue",
  },
  {
    number: "02",
    title: "Manual handovers",
    body: "Approvals and decisions depend on messages, memory and follow-up.",
    tone: "pink",
  },
  {
    number: "03",
    title: "Late reporting",
    body: "Management sees the outcome after the opportunity to intervene.",
    tone: "green",
  },
];

export default function CustomDevelopmentOperationalFriction() {
  return (
    <section
      className="custom-development-operational-friction"
      id="custom-development-challenge"
      aria-labelledby="custom-development-operational-friction-title"
    >
      <img
        className="custom-development-operational-friction__background"
        src={customDevelopmentOperationalFrictionDarkBackground}
        alt=""
        aria-hidden="true"
      />

      <div className="custom-development-operational-friction__inner">
        <div className="custom-development-operational-friction__copy">
          <p className="custom-development-operational-friction__eyebrow">The operational problem</p>
          <h2 id="custom-development-operational-friction-title">
            Most operational friction lives between systems.
          </h2>
          <p className="custom-development-operational-friction__body">
            Work moves through inboxes, spreadsheets, chat threads and disconnected
            platforms. Every handover introduces delay, duplication and blind spots.
          </p>
        </div>

        <picture className="custom-development-operational-friction__visual">
          <source media="(max-width: 699px)" srcSet={customDevelopmentOperationalFrictionFragmentedWorkflowMobile} />
          <img src={customDevelopmentOperationalFrictionFragmentedWorkflowDesktop} alt="Disconnected inbox, spreadsheet, chat and legacy platform records separated by a process gap." />
        </picture>

        <div className="custom-development-operational-friction__signals">
          {customDevelopmentOperationalFrictionSignals.map((signal) => (
            <article
              className={`custom-development-operational-friction__signal custom-development-operational-friction__signal--${signal.tone}`}
              key={signal.number}
            >
              <span className="custom-development-operational-friction__signal-number">{signal.number}</span>
              <h3>{signal.title}</h3>
              <p>{signal.body}</p>
            </article>
          ))}
        </div>

        <p className="custom-development-operational-friction__principle">
          <span aria-hidden="true" />
          Automating a broken process only moves the bottleneck faster.
        </p>
      </div>
    </section>
  );
}
